template_directory = site.theme_path;

(function($) {

   $(function () { 
        $('.navbar-brand-img').addClass('scroll-top');
        $(window).scroll(function () {
            if ($(this).scrollTop() > 50) { 
                $('.scrolled-top img').attr('src',template_directory+'/assets/img/andrew_house_dental_logo.png');
                $('.navbar-brand-img').toggleClass('scrolled-top scroll-top');
            } else {
                $('.scroll-top img').attr('src',template_directory+'/assets/img/andrew_house_dental_logo_white.png');
                $('.navbar-brand-img').toggleClass('scroll-top scrolled-top');
            }
            
        })
    });

})(jQuery);